import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import BackArrow from "../../backArrow";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import url from "../../../config/axios";
import axios from "axios";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import Loader from "../../Loader";

const JobApplicationForm = (props) => {
  const { id } = useParams();
  const isUpdateMode = Boolean(id);
  const location = useLocation();
  const { name } = useSelector((state) => state.user);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");
  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");
  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);
  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  const handleSearchChangestate = (event) => {
    setSearchTermone(event.target.value);
  };

  const handleSearchChangecity = (event) => {
    setSearchTermtwo(event.target.value);
  };

  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };

  const [infooo, setInfooo] = useState();
  const [employeedata, setEmployeedata] = useState();
  const [isloading, setIsloading] = useState(false);
  const navigate = useNavigate();
  const [shopCategory, setShopCategory] = useState();

  const [titlename, setTitlename] = useState({
    jobtitle: "",
  });
  const [jobdataone, SetJobdataone] = useState({
    categoryid: "",
  });

  const handlename = (e) => {
    setTitlename((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
    // Reset dependent category selects when job section changes
    SetJobdataone({ categoryid: "" });
    SetJobcategory([]);
    SetJobcategorytwo([]);
    setJobData((prev) => ({
      ...prev,
      categoryid: "",
      subCategoryid: "",
    }));
  };

  const [jobcategory, SetJobcategory] = useState();
  const [jobcategorytwo, SetJobcategorytwo] = useState();

  const Handlejobdata = (e) => {
    SetJobdataone((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
    SetJobcategorytwo([]);
    setJobData((prev) => ({
      ...prev,
      subCategoryid: "",
    }));
  };

  const Title_Name = Array.isArray(titlename?.jobtitle)
    ? titlename.jobtitle[1]
    : undefined;
  const categoryName = Array.isArray(jobdataone?.categoryid)
    ? jobdataone.categoryid[1]
    : undefined;
  const categoryidd = Array.isArray(jobdataone?.categoryid)
    ? jobdataone.categoryid[0]
    : undefined;

  useEffect(() => {
    if (!name?._id) return;

    // Get user info
    url.get(`/user/id?id=${name?._id}`).then((response) => {
      setInfooo(response?.data?.data?.User);
    });

    // Get employee application
    url
      .get(`/employee/userid?userid=${name?._id}`)
      .then((response) => {
        const employee = response?.data?.data?.Employee;
        const success = response?.data?.success;

        setEmployeedata(employee);

        // 🚫 If in Update mode, NEVER auto redirect
        if (isUpdateMode) {
          return;
        }

        if (success && employee?._id) {
          const viewPath = `/view-application/${employee._id}`;
          navigate(viewPath);
        }
      })
      .catch(() => {
        // No existing application — stay on create form
      });
  }, [name?._id, id]);

  useEffect(() => {
    if (!employeedata) return;

    setJobData((prev) => ({
      ...prev,
      jobtitle: employeedata.jobtitle,
      jobtype: employeedata.jobtype,
      country: employeedata.country,
      state: employeedata.state,
      city: employeedata.city,
      categoryid: employeedata.categoryid,
      subCategoryid: employeedata.subCategoryid,
      jobexperience: employeedata.jobexperience,
      salarywant: employeedata.salarywant,
      siteremote: employeedata.siteremote,
      jobdescription: employeedata.jobdescription,
      image: employeedata.image,
    }));

    setSelectedCountry(employeedata.country);
    setSelectedstateone(employeedata.state);
    setSelectedcity(employeedata.city);
  }, [employeedata]);

  const [jobData, setJobData] = useState({
    userid: name._id,
    jobtitle: "",
    jobtype: "",
    country: "",
    categoryid: categoryidd,
    category: "",
    subCategoryid: "",
    city: "",
    state: "",
    jobexperience: "",
    image: [],
    name: name.fullname,
    siteremote: "",
    salarywant: "",
    jobdescription: "",
    duration: new Date(),
    status: true,
  });

  useEffect(() => {
    setJobData((jobData) => ({
      ...jobData,
      image: infooo?.imageUrl,
      jobtitle: Title_Name,
    }));
    // ...
  }, [infooo, Title_Name]);
  useEffect(() => {
    setJobData((prev) => ({
      ...prev,
      categoryid: categoryidd,
    }));
  }, [categoryidd]);

  // Level 1: job sections (type jobs, empty parent)
  useEffect(() => {
    url
      .get("/category/type/", { params: { type: "jobs", parentCategory: "" } })
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategory(response?.data?.data?.Category);
        }
      })
      .catch(() => {});
  }, []);

  // Level 2: job categories under selected section
  const Mydatatwo = () => {
    if (!Title_Name) {
      SetJobcategory([]);
      return;
    }
    url
      .get("/category/type/", {
        params: { type: "jobs", parentCategory: Title_Name },
      })
      .then(async (response) => {
        if (response?.data?.success) {
          SetJobcategory(response?.data?.data?.Category);
        } else {
          SetJobcategory([]);
        }
      })
      .catch(() => {
        SetJobcategory([]);
      });
  };

  // Level 3: job sub-categories under selected category
  const Mydatathree = () => {
    if (!categoryName) {
      SetJobcategorytwo([]);
      return;
    }
    url
      .get("/category/type/", {
        params: { type: "jobSubItem", parentCategory: categoryName },
      })
      .then(async (response) => {
        if (response?.data?.success) {
          SetJobcategorytwo(response?.data?.data?.Category);
        } else {
          SetJobcategorytwo([]);
        }
      })
      .catch(() => {
        SetJobcategorytwo([]);
      });
  };

  // Prefetch children when parent selection changes (so dropdowns are not empty on open)
  useEffect(() => {
    if (!Title_Name) {
      SetJobcategory([]);
      SetJobcategorytwo([]);
      return;
    }
    Mydatatwo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Title_Name]);

  useEffect(() => {
    if (!categoryName) {
      SetJobcategorytwo([]);
      return;
    }
    Mydatathree();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryName]);

  useEffect(() => {
    url
      .get(`/employee/userid/?userid=${name?._id}`)
      .then(async (response) => {
        setEmployeedata(response?.data?.data?.Employee);
      })
      .catch(() => {});
  }, []);

  const JobSubmit = (e) => {
    setIsloading(true);
    e.preventDefault();
    url
      .post("/employee/", jobData)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Form Createjob Created Successfully");
            navigate(`/view-application/${response?.data?.data?._id}`);
          }, 1000);
        }
      })
      .catch(() => {
        setIsloading(false);
        FailedNotify("Submission Failed ! Try Again");
      });
  };

  const JobUpdate = (e) => {
    setIsloading(true);
    e.preventDefault();
    url
      .put(`/employee/id/?id=${id}`, jobData)
      .then(async (response) => {
        if (response.data.success) {
          setIsloading(false);
          SuccessNotify("Form Createjob Updated Successfully");
          setTimeout(() => {
            navigate("/view-application/" + id);
          }, 1000);
        }
      })
      .catch((error) => {
        setIsloading(false);

        FailedNotify("Form Updation Failed ! Try Again");
      });
  };

  const InputJob = (event) => {
    setJobData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    axios
      .get(
        "https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json",
      )
      .then((res) => SetCountrydata(res.data))

      .catch((error) => {});
  }, []);

  const country = [...new Set(countrydata.map((item) => item.country))];

  country.sort();

  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value,
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value,
    );
    setGetcity(cities);
  };
  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  return (
    <Row>
      <form>
        <div className="screenHeight d-flex justify-content-center align-items-center">
          <Col lg={9} md={10} sm={9} xs={12} className="Form-Shadow ">
            <div className="arrowback pb-1 ">
              <BackArrow
                back={props.back}
                black="black"
                mystyle="p-1 ps-4 pt-2"
              />
            </div>
            <div className="px-4">
              <Form.Label className="custm-lble pt-1 ps-4">
                Job Wanted
              </Form.Label>
              <Form onSubmit={(e) => JobSubmit(e)}>
                {["radio"].map((type) => (
                  <div key={`inline-${type}`} className="mb-2 ps-4">
                    <Form.Check
                      inline
                      label="Full time"
                      name="jobtype"
                      type="radio"
                      value="full time"
                      checked={jobData.jobtype === "full time"}
                      onChange={InputJob}
                    />

                    <Form.Check
                      inline
                      label="Part time"
                      name="jobtype"
                      type="radio"
                      value="part time"
                      checked={jobData.jobtype === "part time"}
                      onChange={InputJob}
                    />
                  </div>
                ))}
              </Form>
              <Row className="ps-4 pe-4">
                <Col md={4} lg={4} xl={4}>
                  <Form.Label className="custm-lble pb-1">
                    Select Job
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="jobtitle"
                    onChange={(e) => handlename(e)}
                    className="input-style form-control-seller"
                  >
                    <option selected disabled>
                      Select job title
                    </option>
                    {shopCategory?.map((category) => (
                      <option
                        key={category._id}
                        value={`${category?._id}.${category?.name}`}
                      >
                        {category?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={4} lg={4} xl={4}>
                  <Form.Label className="custm-lble pb-1">
                    Job Category
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="categoryid"
                    className="input-style form-control-seller"
                    onChange={(e) => {
                      Handlejobdata(e);
                    }}
                    onClick={Mydatatwo}
                  >
                    <option selected disabled>
                      job category
                    </option>
                    {jobcategory?.map((category) => (
                      <>
                        <option
                          key={category._id}
                          value={`${category?._id}.${category?.name}`}
                        >
                          {category?.name}
                        </option>
                      </>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={4} lg={4} xl={4}>
                  <Form.Label className="custm-lble pb-1">
                    Job Sub-Category
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    name="subCategoryid"
                    className="input-style form-control-seller"
                    onChange={(e) => {
                      InputJob(e);
                    }}
                    onClick={Mydatathree}
                  >
                    {" "}
                    <option selected disabled>
                      job sub category
                    </option>{" "}
                    {jobcategorytwo?.map((subcategory) => (
                      <>
                        <option key={subcategory._id} value={subcategory?._id}>
                          {subcategory?.name}
                        </option>
                      </>
                    ))}
                  </Form.Select>
                </Col>

                <div className="col-md-4">
                  <label className="form-label labelSize">Country*</label>
                  <div className="input-style  blood-type">
                    <select
                      onChange={(e) => {
                        handleCountryChange(e);
                        handleCountry(e);
                        InputJob(e);
                      }}
                      className="b-radius selectSize w-100 p-2"
                      name="country" // Non-standard name
                      autoComplete="off"
                    >
                      <option>Select-Country</option>

                      {country.map((c) => (
                        <option key={c} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label labelSize">State*</label>
                  <div className="input-style  blood-type">
                    <select
                      className="b-radius selectSize w-100 p-2"
                      aria-label="Default select example"
                      name="state" // Non-standard name
                      onChange={(e) => {
                        InputJob(e);
                        handleState(e);
                        handleCountryChangestate(e);
                      }}
                      autoComplete="off"
                    >
                      <option>Select-State</option>

                      {getState.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label labelSize">City</label>
                  <div className="input-style  blood-type">
                    <select
                      className="b-radius selectSize w-100 p-2"
                      aria-label="Default select example"
                      name="city" // Non-standard name
                      onChange={(e) => {
                        InputJob(e);
                        handleCountryChangecity(e);
                      }}
                      autoComplete="off"
                    >
                      <option>Select-City</option>

                      {getcity.map((city) => (
                        <option key={city.name} value={city.name}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <Col className="pt-2" md={3} lg={4} xl={4} sm={12} xs={12}>
                  <Form.Label className="custm-lble ">
                    Job Experience
                  </Form.Label>
                  <Form.Control
                    placeholder="Job Experience"
                    onChange={(e) => InputJob(e)}
                    name="jobexperience"
                    className="input-style ps-3 pe-3 form-control-seller"
                    // defaultValue={employeedata?.jobexperience}
                    value={jobData.jobexperience || ""}
                  />
                </Col>
                <Col className="pt-2" md={3} lg={4} xl={4}>
                  <Form.Label className="custm-lble">
                    Salary You Want
                  </Form.Label>
                  <Form.Control
                    placeholder="Salary You Want"
                    onChange={(e) => InputJob(e)}
                    name="salarywant"
                    className="input-style form-control-seller"
                    // defaultValue={employeedata?.salarywant}
                    value={jobData.salarywant || ""}
                  />
                </Col>
              </Row>

              <Form.Label className="custm-lble mb-0 pb-1 ps-4">
                OnSite/Remotely/Hybrid
              </Form.Label>
              <Form>
                {["radio"].map((type) => (
                  <div key={`inline-${type}`} className="mb-2 ps-4">
                    <Form.Check
                      inline
                      label="onsite"
                      name="siteremote"
                      type={type}
                      id={`inline-${type}-1`}
                      className="labelText"
                      value="onsite"
                      onChange={(e) => InputJob(e)}
                    />
                    <Form.Check
                      inline
                      label="Remotely"
                      name="siteremote"
                      type="radio"
                      value="remote"
                      checked={jobData.siteremote === "remote"}
                      onChange={InputJob}
                    />

                    <Form.Check
                      inline
                      label="Hybrid"
                      name="siteremote"
                      type={type}
                      id={`inline-${type}-2`}
                      className="labelText"
                      value="hybrid"
                      onChange={(e) => InputJob(e)}
                    />
                  </div>
                ))}
              </Form>

              <div className="ps-4 pe-4">
                <Form.Label className="custm-lble pb-1">
                  Add Description
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  className="input-style"
                  placeholder="Add Description"
                  name="jobdescription"
                  onChange={(e) => InputJob(e)}
                  // defaultValue={employeedata?.jobdescription}
                  value={jobData.jobdescription || ""}
                />
              </div>

              <div className="btns pe-4 pb-3 pt-3">
                <button className="btn1" onClick={() => navigate("/CV-Form")}>
                  Cancel
                </button>
                <Button
                  className="btn2 p-1"
                  variant="primary"
                  onClick={
                    props.butn === "Post"
                      ? (e) => JobSubmit(e)
                      : (e) => JobUpdate(e)
                  }
                >
                  {props.butn}
                </Button>
              </div>
            </div>
          </Col>
        </div>
      </form>
    </Row>
  );
};
export default JobApplicationForm;
